import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useWishlist } from "@/context/WishlistContext";
import ProductCard from "@/components/ProductCard";
import { Heart } from "lucide-react";

export default function WishlistPage() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    async function load() {
      if (ids.length === 0) { setProducts([]); return; }
      const { data } = await api.get("/products", { params: { limit: 200 } });
      setProducts(data.filter((p) => ids.includes(p.id)));
    }
    load();
  }, [ids]);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
      <h1 className="font-heading font-medium text-4xl sm:text-5xl mb-8">Wishlist</h1>
      {products.length === 0 ? (
        <div className="text-center py-16">
          <Heart className="w-10 h-10 mx-auto text-muted-foreground" />
          <div className="mt-4 font-heading text-xl">Nothing saved yet</div>
          <div className="mt-1 text-sm text-muted-foreground">Tap the heart on any product to save it here.</div>
          <Link to="/shop" className="mt-6 inline-flex h-11 px-6 items-center rounded-full bg-electric text-white text-sm font-medium hover:bg-electric-600 transition-colors">Browse products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
